import React, { Component } from 'react';
import InwardingApiHandlerTest from '../../../InwardingApiHandlerTest';
import CircularProgress from '@material-ui/core/CircularProgress';
import ProductInfo2Test from '../ProductInfo2Test';
import ErrorBox from '../../../../../commons/ErrorBox';
import info from './../../../../../assets/img/info-button.png';
import close from './../../../../../assets/img/close.png';
import Dialog from '@material-ui/core/Dialog';
import InputFloating from './../../../../../commons/InputFloating.js';

export default class SelectParentTest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vinv: props.vinv,
            palletId: props.palletId,
            shortInward: false,
            parentProducts: [],
            loading: false,
            product: {},
            shortInwardReason: '',
            shortInwardTrueReason: '',
            otherReason: '',
            error: '',
        };
    }

    componentDidMount = () => {
        this.setState({ loading: true });
        InwardingApiHandlerTest.callParentListingApi(this.state.vinv)
            .then((resp) => {
                // RESP can also BE NULL
                if (resp && resp.productReceivedDetailsList) {
                    this.setState({
                        parentProducts: resp.productReceivedDetailsList,
                    });
                }
            })
            .catch((error) => {
                this.setState({ error: error.error.error });
            })
            .finally((e) => {
                this.setState({ loading: false });
            });
    };

    closeError = () => {
        // close error dialog box
        this.setState({ error: '' });
    };

    closeShortInwardBox = () => {
        this.setState({ shortInward: false });
    };

    setNameToValue = (e) => {
        const name = e.target.name;
        let val = e.target.value;

        this.setState({
            [name]: val,
        });
    };

    proceedClicked = () => {
        const {
            shortInwardReason,
            product,
            vinv,
            palletId,
            shortInwardTrueReason,
            otherReason,
        } = this.state;
        let req = {
            product_name: product.productInfoResponse.title,
            jpin: product.productInfoResponse.jpin,
            mrp: product.mrp,
            listing_id: product.listingId,
            received_quantity: product.receivedQuantity,
            purchase_order_quantity: product.purchaseOrderQuantity,
            inwarding_session_id: vinv,
            gric: palletId,
            is_parent_short_inward: true,
        };

        //let reason = shortInwardTrueReason;
        //if (shortInwardTrueReason === 'Other') {
        //    reason = otherReason;
        //}

        if (shortInwardReason === 'yes') {
            req['all_parent_products_inwarded'] = 'yes';
            //req['parent_short_inward_reason'] = reason;
            this.props.triggerEvent('ON_SELECT_PARENT_SHORT_INWARD', req);
            this.manufacturerOfferCheck(product);
        } else if (shortInwardReason === 'no') {
            req['all_parent_products_inwarded'] = 'no';
            this.props.triggerEvent('ON_SELECT_PARENT_SHORT_INWARD', req);
            this.setState({ shortInward: false }, () => {
                this.props.onClose();
            });
        }
    };

    manufacturerOfferCheck = (product) => {
        if (product.manufacturerOffer) {
            if (product.manufacturerOffer.offerJPIN) {
                //if offer jpin is present, go to select freebie listings
                this.props.onClick(
                    product.manufacturerOffer.offerJPIN,
                    product.listingId,
                    product.productInfoResponse.title
                );
            } else {
                //if offerJpin is null, go to add new freebie page
                this.props.history.push({
                    pathname: '/Inwarding/AddNewFreebie',
                    state: {
                        vinv: this.state.vinv,
                        palletId: this.state.palletId,
                        parentListingId: product.listingId,
                        parentListingTitle: product.productInfoResponse.title,
                    },
                });
            }
        }
    };

    cardClicked = (product) => {
        if (product.receivedQuantity < product.purchaseOrderQuantity) {
            //if short inward, throw confirmation dialog box
            this.setState({ shortInward: true, product: product });
        } else {
            this.manufacturerOfferCheck(product);
        }
    };

    validateReason = () => {
        const { shortInwardReason, shortInwardTrueReason, otherReason } =
            this.state;
        if (shortInwardReason === 'yes' || shortInwardReason === 'no') {
            return true;
        }
        return false;
    };

    render() {
        const {
            loading,
            parentProducts,
            error,
            shortInward,
            shortInwardReason,
            shortInwardTrueReason,
            otherReason,
            vinv,
            palletId,
        } = this.state;
        return (
            <div style={{ padding: '20px', textAlign: 'center' }}>
                {/* heading */}
                <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                    <div className='dc-num'>
                        Please select the parent product from the following
                        list:
                    </div>
                    <img
                        src={close}
                        style={{ height: '23px', margin: '2px 0px 0px 5px' }}
                        onClick={this.props.onClose}
                        alt='Img'
                    />
                </div>

                {/* line */}
                <div
                    style={{
                        borderBottom: '2px solid #dfdfdf',
                        marginTop: '10px',
                    }}
                ></div>

                {loading ? (
                    <div style={{ padding: '20px' }}>
                        <CircularProgress
                            style={{ color: '#000' }}
                            size={23}
                            thickness={3}
                        />
                    </div>
                ) : (
                    <div>
                        {parentProducts.length > 0 ? (
                            <React.Fragment>
                                {parentProducts.map((prod, index) => {
                                    return (
                                        <div
                                            key={prod.listingId}
                                            onClick={() => {
                                                this.cardClicked(prod);
                                                this.props.triggerEvent(
                                                    'ON_SELECT_PARENT_PRODUCT_FOR_NON_PO_FREEBIE',
                                                    {
                                                        product_name:
                                                            prod
                                                                .productInfoResponse
                                                                .title,
                                                        jpin: prod
                                                            .productInfoResponse
                                                            .jpin,
                                                        mrp: prod.mrp,
                                                        listing_id:
                                                            prod.listingId,
                                                        received_quantity:
                                                            prod.receivedQuantity,
                                                        purchase_order_quantity:
                                                            prod.purchaseOrderQuantity,
                                                        inwarding_session_id:
                                                            vinv,
                                                        gric: palletId,
                                                    }
                                                );
                                            }}
                                            className='product-box'
                                        >
                                            <ProductInfo2Test product={prod} />
                                        </div>
                                    );
                                })}
                            </React.Fragment>
                        ) : (
                            <div
                                style={{
                                    padding: '50px 30px',
                                    color: '#BD2E23',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <img
                                    src={info}
                                    style={{
                                        height: '21px',
                                        marginRight: '10px',
                                    }}
                                    alt='Img'
                                />
                                <div>No Parent Listings available</div>
                            </div>
                        )}
                    </div>
                )}

                <Dialog
                    open={shortInward}
                    maxWidth='lg'
                    fullWidth={true}
                    onClose={this.closeShortInwardBox}
                    classes={{ paper: 'tw-margn-class' }}
                >
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                        <div className='dc-num'>
                            Are you sure you have inwarded all the quantities of
                            the parent product as per invoice?
                        </div>
                        <div
                            style={{
                                borderBottom: '2px solid #dfdfdf',
                                marginTop: '10px',
                            }}
                        ></div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                margin: '20px 10px 10px 10px',
                            }}
                        >
                            <input
                                type='radio'
                                name='shortInwardReason'
                                id='shortInwardOption1'
                                value={'yes'}
                                onChange={(e) => {
                                    this.setNameToValue(e);
                                }}
                                style={{ marginRight: '5px' }}
                            />
                            <label
                                htmlFor='shortInwardOption1'
                                style={{ textAlign: 'left' }}
                            >
                                Yes
                            </label>
                        </div>
                        {/*{shortInwardReason === 'yes' ? (
                            <div style={{ marginLeft: '20px' }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        margin: '20px 10px 10px 10px',
                                    }}
                                >
                                    <input
                                        type='radio'
                                        name='shortInwardTrueReason'
                                        id='shortInwardTrueOption1'
                                        value={'Vendor Supplied Less'}
                                        onChange={(e) => {
                                            this.setNameToValue(e);
                                        }}
                                        style={{ marginRight: '5px' }}
                                    />
                                    <label
                                        htmlFor='shortInwardTrueOption1'
                                        style={{
                                            textAlign: 'left',
                                            fontWeight: '500',
                                            fontSize: '13px',
                                        }}
                                    >
                                        Vendor Supplied Less
                                    </label>
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        margin: '10px',
                                    }}
                                >
                                    <input
                                        type='radio'
                                        name='shortInwardTrueReason'
                                        id='shortInwardTrueOption2'
                                        value={'Some Products Damaged'}
                                        onChange={(e) => {
                                            this.setNameToValue(e);
                                        }}
                                        style={{ marginRight: '5px' }}
                                    />
                                    <label
                                        htmlFor='shortInwardTrueOption2'
                                        style={{
                                            textAlign: 'left',
                                            fontWeight: '500',
                                            fontSize: '13px',
                                        }}
                                    >
                                        Some Products Damaged
                                    </label>
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        margin: '10px',
                                    }}
                                >
                                    <input
                                        type='radio'
                                        name='shortInwardTrueReason'
                                        id='shortInwardTrueOption3'
                                        value={'Other'}
                                        onChange={(e) => {
                                            this.setNameToValue(e);
                                        }}
                                        style={{ marginRight: '5px' }}
                                    />
                                    <label
                                        htmlFor='shortInwardTrueOption3'
                                        style={{
                                            textAlign: 'left',
                                            fontWeight: '500',
                                            fontSize: '13px',
                                        }}
                                    >
                                        Other
                                    </label>
                                </div>
                                {shortInwardTrueReason === 'Other' ? (
                                    <InputFloating
                                        type='text'
                                        label='Other Reason'
                                        value={otherReason}
                                        onChange={(e) => {
                                            this.setState({
                                                otherReason: e.target.value,
                                            });
                                        }}
                                    />
                                ) : null}
                            </div>
                        ) : null}*/}

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                margin: '10px',
                            }}
                        >
                            <input
                                type='radio'
                                name='shortInwardReason'
                                id='shortInwardOption2'
                                value={'no'}
                                onChange={(e) => {
                                    this.setNameToValue(e);
                                }}
                                style={{ marginRight: '5px' }}
                            />
                            <label
                                htmlFor='shortInwardOption2'
                                style={{ textAlign: 'left' }}
                            >
                                No
                            </label>
                        </div>
                        {shortInwardReason === 'no' ? (
                            <div className='errorText'>
                                Please Inward all quantities of the parent
                                product
                            </div>
                        ) : null}

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-evenly',
                                marginTop: '80px',
                            }}
                        >
                            <button
                                className='btn'
                                onClick={this.closeShortInwardBox}
                            >
                                Cancel
                            </button>
                            <button
                                disabled={!this.validateReason()}
                                className='btn btn-jt-green'
                                onClick={this.proceedClicked}
                            >
                                Proceed
                            </button>
                        </div>
                    </div>
                </Dialog>

                {/* display custom errors OR error message from api failures */}
                {error ? (
                    <ErrorBox errorText={error} closeError={this.closeError} />
                ) : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/InwardingTest/ComponentsTest/CommonsTest/AddPalletUITest/SelectParentTest.js